/* eslint-disable no-unused-vars */
import React from "react";

export const currentDate = () => {
    const dateNow = new Date(); // Creating a new date object with the current date and time
    const year = dateNow.getFullYear(); // Getting current year from the created Date object
    const monthWithOffset = dateNow.getUTCMonth() + 1; // January is 0 by default in JS. Offsetting +1 to fix date for calendar.
    const month = // Setting current Month number from current Date object
    monthWithOffset.toString().length < 2 // Checking if month is < 10 and pre-prending 0 if not to adjust for date input.
        ? `0${monthWithOffset}`
        : monthWithOffset;
    const date =
    dateNow.getUTCDate().toString().length < 2 // Checking if date is < 10 and pre-prending 0 if not to adjust for date input.
        ? `0${dateNow.getUTCDate()}`
        : dateNow.getUTCDate();

    const materialDateInput = `${year}-${month}-${date}`; // combining to format for defaultValue or value attribute of material <TextField>
    return materialDateInput;
}
export default currentDate;

export const uniqueFormID = () => {
  // Create a secure random value and convert it to base36
  const array = new Uint32Array(3); // Use a length of 3 to generate 24 characters
  window.crypto.getRandomValues(array);
  const randomString = array.join('').toString(36).substr(0, 6).toUpperCase()+Date.now().toString();
  return 'PBUKYC-' + randomString;
}

/*export const uniqueServiceFormID=()=>{
    return 'PBUSR-' + (Math.random()*Date.now()).toString(36).substr(2, 6).toUpperCase();
}*/



// A Set to store generated IDs to ensure uniqueness
const generatedIdsSet = new Set();

export const uniqueServiceFormID = () => {
  const generateUniqueId = () => {
    // Prefix: Fixed at 6 characters
    const prefix = "PBUSR-";

    // Random Part: Generate 7 random characters
    const randomPart = generateSecureRandomString(); // Always 7 chars

    // Timestamp Part: Generate 8 characters from a high-precision timestamp (remove decimals)
    const timestampPart = Math.floor(performance.now()).toString(36).substring(0, 8).toUpperCase();

    // Combine random and timestamp parts, and trim if necessary to make it 15 characters
    const uniqueId = `${prefix}${randomPart}${timestampPart}`.substring(0, 15);

    return uniqueId;
  };

  let newId = generateUniqueId();

  // Ensure the generated ID is unique
  while (generatedIdsSet.has(newId)) {
    newId = generateUniqueId();
  }

  // Add the new ID to the Set
  generatedIdsSet.add(newId);
  console.log("The Unique value is: "+newId);
  return newId;
};

const getSecureRandomInt = (min, max) => {
  const randomBytes = new Uint32Array(1);
  crypto.getRandomValues(randomBytes);
  return min + (randomBytes[0] % (max - min + 1));
};

const generateSecureRandomString = (length = 7) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from({ length }, () => chars[getSecureRandomInt(0, chars.length - 1)]).join("");
};